import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { EmergencyFilter } from '../../../models/emergency-filter.model';
import { EmergencyStatus } from 'src/app/web-api-client';
import { EmergencyStatusTypes } from '../../../enums/emergency-status.enum';

@Component({
  selector: 'app-emergency-filter-form',
  templateUrl: './emergency-filter-form.component.html',
  styleUrl: './emergency-filter-form.component.scss'
})
export class EmergencyFilterFormComponent implements OnInit, OnDestroy, OnDestroy {
  @Input() emergencyStatusesList: EmergencyStatus[] = [];
  @Input() initialFilter: EmergencyFilter = null;
  @Output() filterClicked = new EventEmitter<EmergencyFilter>();

  private subscriptions = new Subscription();
  public emergencyFilterForm: FormGroup;

  private _initialFilter: EmergencyFilter;

  private componentIntialized = false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    if(this.initialFilter) {
      this._initialFilter = JSON.parse(JSON.stringify(this.initialFilter));
    }
    this.initializeSignalFilterForm();
    this.componentIntialized = true;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(!this.componentIntialized) {
      return;
    }

    if(changes.initialFilter && !changes.initialFilter.firstChange) {
      this._initialFilter = JSON.parse(JSON.stringify(this.initialFilter));
      this.initializeSignalFilterForm();
    }
  }

  public onEmergencyListFilterFormSubmit($event: SubmitEvent) {
    const startDate: Date = this.emergencyFilterForm.value.startDate ? new Date(this.emergencyFilterForm.value.startDate) : null;
    const endDate: Date = this.emergencyFilterForm.value.endDate ? new Date(this.emergencyFilterForm.value.endDate) : null;
    const emergencyStatusType: EmergencyStatusTypes = this.emergencyFilterForm.value.signalStatus || null;

    if(startDate !== null || endDate !== null || emergencyStatusType !== null) {
      const signalsSearchFilter: EmergencyFilter = {
        startDate, endDate, emergencyStatusType
      }

      this.filterClicked.emit(signalsSearchFilter);
    }
  }

  public clearFilters() {
    this.emergencyFilterForm.patchValue({
      startDate: null,
      endDate: null,
      emergencyStatus: null
    });

    this.changeDetectorRef.detectChanges();
  }

  public resetForm() {
    this.emergencyFilterForm.reset();
    this._initialFilter = null;
  }

  private initializeSignalFilterForm() {
    this.emergencyFilterForm = this.fb.group({
      startDate: [this._initialFilter ? this._initialFilter.startDate : null],
      endDate: [this._initialFilter ? this._initialFilter.endDate : null],
      signalStatus: [this._initialFilter ? this._initialFilter.emergencyStatusType : null]
    });
  }
}
